import styled from 'styled-components';
import { color } from '../../../../Assets/color';

export const FormModalContainer = styled.div`
    width: 620px;
    max-height: 600px;
    padding: 25px 100px;
    overflow: scroll;

    background-color: #000;
    border-radius: 16px;
    border: 1px solid #353535;
    position: relative;

    display: flex;
    justify-content: center;
`;

export const FormModalContent = styled.div`
    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const WhiteButton = styled.button`
    width: 190px;
    height: 46px;
    border-radius: 100px;
    background-color: #ffffff;
    font-size: 15px;
    color: ${color('red')}
    font-weight: 100;
    text-transform: uppercase;
`;

export const SelectContainer = styled.div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`;

export const PreviewItemImage = styled.div`
    width: 100%;
    height: 81px;
    border-radius: 7px;
    margin-bottom: 16px;
    cursor: pointer;
    background-image: url(${props => (props.background ? props.background : null)});
    background-size: 100% 81px;
    background-repeat: no-repeat;
    &:hover {
        opacity: 0.75;
    }

    transition: all 0.25s;
`;

export const PreviewWorkoutItemImage = styled(PreviewItemImage)`
    background-color: #212121;
    display: flex;
    justify-content: center;
    align-items: center;

    ${props => {
        if (props.disabled) {
            return `
                transition: none;
                opacity: 0.5;
                cursor: default;

                &:hover {
                    opacity: 0.5;
                }
            `;
        }
    }};
`;

export const PreviewItemContainer = styled.div`
    width: 125px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 10px;
`;

export const DurationInput = styled.input`
    width: 80px;
    height: 30px;
    border-radius: 2px;
    background-color: rgba(239, 240, 242, 0.18);
    color: #c5cacf;
    font-size: 14px;
    font-weight: 100px;
    text-align: center;
    border: none;
    margin: 0 14px;
`;



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/GymTvConfigurationsModal/style.js